export const GET_ALL_CATEGORYWISE_SUBCATEGORY_REQUEST =
  "GET_ALL_CATEGORYWISE_SUBCATEGORY_REQUEST";
export const GET_ALL_CATEGORYWISE_SUBCATEGORY_SUCCESS =
  "GET_ALL_CATEGORYWISE_SUBCATEGORY_SUCCESS";
export const GET_ALL_CATEGORYWISE_SUBCATEGORY_FAILURE =
  "GET_ALL_CATEGORYWISE_SUBCATEGORY_FAILURE";
